module.exports = __webpack_public_path__ + "static/media/b1.ae7145d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/suchunyuan/b1.mp3
// module id = u5l8
// module chunks = 0